import { createAction } from 'redux-actions'

// Membership Selections ---------------------------
export const setSelectedMembershipType = createAction(
  'SET_SELECTED_MEMBERSHIP_TYPE'
)

// Gift Recipient ----------------------------------
export const setGiftMessage = createAction('SET_GIFT_MESSAGE')
export const setRecipientContact = createAction('SET_RECIPIENT_CONTACT')

// Billing -----------------------------------------
export const setBillingContact = createAction('SET_BILLING_CONTACT')

// Confirmation ------------------------------------
export const clearAllGiftState = createAction('CLEAR_ALL_GIFT_STATE')
